export default __webpack_public_path__ + "static/media/clap.56044b6a.wav";